/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const putApiProjectsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const putApiProjectsId200Schema = z.any();

export const putApiProjectsIdMutationRequestSchema = z.object({
  id: z.coerce.number().int().nullable().nullish(),
  name: z.coerce.string().min(0).max(500),
  description: z.coerce.string().min(0).max(500).nullable(),
  client: z.object({
    value: z.coerce.number().int(),
    label: z.coerce.string(),
  }),
  projectPriority: z
    .object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    })
    .nullable()
    .nullish(),
  office: z
    .object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    })
    .nullable()
    .nullish(),
  macroProject: z
    .object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    })
    .nullable()
    .nullish(),
  projectState: z
    .object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    })
    .nullable()
    .nullish(),
  requestDate: z.string().date().nullable().nullish(),
  beginningDate: z.string().date().nullable().nullish(),
  conclusionDate: z.string().date().nullable().nullish(),
  expectedConclusionDate: z.string().date().nullable().nullish(),
  notes: z.coerce.string().min(0).max(500).nullable().nullish(),
  requestNumber: z.coerce.number().int().nullable().nullish(),
  requestedBy: z.coerce.string().min(0).max(500).nullable().nullish(),
  requestTakenBy: z.coerce.string().min(0).max(500).nullable().nullish(),
});

export const putApiProjectsIdMutationResponseSchema = z.lazy(
  () => putApiProjectsId200Schema,
);
